import { memo } from 'react';
import type { CSSProperties, ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Heading,
    Table,
    TableBody,
    TableHeader,
    TableHeaderCell,
    TableRow,
} from '@library';

import type { ProductVehicle } from '../../../types';
import ProductCompatibilityVehicleRow from './ProductCompatibilityVehicleRow';
import styles from './ProductVariantsTable.module.scss';

const TableHeadCellTitle = memo(
    ({ messageId, children }: { messageId?: string; children?: ReactNode }) => (
        <Heading h6 semiBold>
            <span>{children || <FormattedMessage id={messageId} />}</span>
        </Heading>
    )
);

const fixedWidthColumns: Record<string, CSSProperties['width']> = {
    model: '21%',
    'type-nr': '15%',
    typeApprovalList: '16%',
};

const VehiclesTable = ({
    vehicles,
    isProductCompatibilityTable = false,
    showTypeColumn,
    onModelChange,
}: {
    vehicles: ProductVehicle[];
    isProductCompatibilityTable?: boolean;
    showTypeColumn: boolean;
    onModelChange: (vehicleId: string) => void;
}) => {
    const headerColumns = showTypeColumn
        ? [
              'make',
              'model',
              'ccm',
              'kw',
              'modelYear',
              'type-nr',
              'typeApprovalList',
          ]
        : ['make', 'model', 'ccm', 'kw', 'modelYear', 'typeApprovalList'];

    return (
        <div className={styles.motorcycleSearchTable}>
            <Table stripedReversed>
                <TableHeader sticky dark>
                    <TableRow>
                        {headerColumns.map(column => (
                            <TableHeaderCell
                                key={column}
                                width={fixedWidthColumns[column] ?? 'auto'}
                            >
                                <TableHeadCellTitle messageId={column} />
                            </TableHeaderCell>
                        ))}
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {vehicles.map(vehicle => (
                        <ProductCompatibilityVehicleRow
                            vehicle={vehicle}
                            showTypeColumn={showTypeColumn}
                            key={vehicle.id}
                            isProductCompatibilityTable={
                                isProductCompatibilityTable
                            }
                            onModelChange={onModelChange}
                        />
                    ))}
                </TableBody>
            </Table>
        </div>
    );
};

export default memo(VehiclesTable);
